import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import RequestFeedButton from './RequestFeedButton';

export default function Nav() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showNavShadow, setShowNavShadow] = React.useState(false);
  const navbarControl = () => {
    if (window.scrollY > 50) {
      setShowNavShadow(true);
    } else {
      setShowNavShadow(false);
    }
  }

  React.useEffect(() => {
    window.addEventListener('scroll', navbarControl);
    return () => window.removeEventListener('scroll', navbarControl)
  },[]);

  return (
    <nav className={`w-full fixed top-0 z-30 ${showNavShadow && 'bg-white shadow'}`}>
      <div className="container flex flex-wrap items-center justify-between w-full py-2 mx-auto mt-0">
        <div className="flex items-center pl-4">
          <div className="flex items-start">
            <NavLink to="/" className="w-40">
              {/* <span className="font-bold text-2xl">Algoracle</span> */}
              <img src="/images/Goracle_Logo.png" alt="Company logo"></img>
            </NavLink>
          </div>
        </div>

        <div className="block pr-4 sm:hidden">
          <button className="flex items-center p-1 hover:text-gray-900 focus:outline-none" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <i className={'fas fa-1x ' + (isMenuOpen ? 'fa-window-close' : 'fa-bars')}></i>
          </button>
        </div>

        <div className={'z-20 flex-grow w-full p-4 bg-white sm:flex sm:items-center sm:w-auto sm:mt-0 sm:bg-transparent sm:p-0 ' + (isMenuOpen ? 'block' : 'hidden')}>
          <ul className="items-center justify-center flex-1 m-3 list-reset sm:flex sm:justify-end sm:gap-4">
            <li className="mr-3 mt-5 sm:mt-0">
              <NavLink
                to="/"
                className={({ isActive }) => (isActive ? 'border-b-2 border-lime-500' : '') + ' pb-1 font-semibold hover:text-lime-500'}>
                  Home
              </NavLink>
            </li>
            <li className="mr-3 mt-5 sm:mt-0">
              <NavLink
                to="/feeds"
                className={({ isActive }) => (isActive ? 'border-b-2 border-lime-500' : '') + ' pb-1 font-semibold hover:text-lime-500'}>
                  Feeds
              </NavLink>
            </li>
            <li className="mr-3 mt-5 sm:mt-0">
              <NavLink
                to="/nodes"
                className={({ isActive }) => (isActive ? 'border-b-2 border-lime-500' : '') + ' pb-1 font-semibold hover:text-lime-500'}>
                  Nodes
              </NavLink>
            </li>
            <li className="mr-3 mt-5 sm:mt-0">
              <RequestFeedButton url={'/request'} />
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
